var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoMetamask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 46",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.6097 0.750641L27.8796 14.6611L31.344 6.45386L46.6097 0.750641Z",
    fill: "#E2761B",
    stroke: "#E2761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.37158 0.750641L21.9511 14.7927L18.6562 6.45386L3.37158 0.750641Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8705 32.9953L34.8823 40.6381L45.5557 43.574L48.6242 33.1648L39.8705 32.9953Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.39478 33.1648L4.44432 43.574L15.1177 40.6381L10.1295 32.9953L1.39478 33.1648Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5155 20.0821L11.5408 24.5816L22.1384 25.0523L21.7624 13.6639L14.5155 20.0821Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4656 20.0821L28.1249 13.5322L27.8796 25.0523L38.4593 24.5816L35.4656 20.0821Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1177 40.6381L21.48 37.5318L15.9833 33.2397L15.1177 40.6381Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5007 37.5318L34.882 40.6381L33.9975 33.2397L28.5007 37.5318Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M34.882 40.6381L28.5007 37.5318L29.0093 41.6922L28.9525 43.4424L34.882 40.6381Z",
    fill: "#D7C1B3",
    stroke: "#D7C1B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1177 40.6381L21.0472 43.4424L21.0094 41.6922L21.48 37.5318L15.1177 40.6381Z",
    fill: "#D7C1B3",
    stroke: "#D7C1B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1413 30.4922L15.833 28.9296L19.5786 27.2163L21.1413 30.4922Z",
    fill: "#233447",
    stroke: "#233447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8398 30.4922L30.4025 27.2163L34.1671 28.9296L28.8398 30.4922Z",
    fill: "#233447",
    stroke: "#233447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1181 40.6381L16.0216 32.9953L10.1299 33.1648L15.1181 40.6381Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9785 32.9953L34.882 40.6381L39.8702 33.1648L33.9785 32.9953Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4593 24.5816L27.8796 25.0523L28.8589 30.4922L30.4216 27.2163L34.1861 28.9296L38.4593 24.5816Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8329 28.9296L19.5974 27.2163L21.1412 30.4922L22.1384 25.0523L11.5408 24.5816L15.8329 28.9296Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5408 24.5816L15.9834 33.2397L15.8329 28.9296L11.5408 24.5816Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1858 28.9296L33.9973 33.2397L38.4589 24.5816L34.1858 28.9296Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1386 25.0523L21.1414 30.4922L22.3839 36.9104L22.6661 28.4589L22.1386 25.0523Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8795 25.0523L27.3718 28.4399L27.5972 36.9104L28.8587 30.4922L27.8795 25.0523Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8587 30.4922L27.5972 36.9105L28.5007 37.5317L33.9974 33.2396L34.1859 28.9296L28.8587 30.4922Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M15.833 28.9296L15.9836 33.2396L21.4803 37.5317L22.3838 36.9105L21.1413 30.4922L15.833 28.9296Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9524 43.4424L29.0092 41.6922L28.5385 41.2774H21.4422L21.0094 41.6922L21.0472 43.4424L15.1177 40.6381L17.188 42.3315L21.3853 45.2494H28.5953L32.8117 42.3315L34.8819 40.6381L28.9524 43.4424Z",
    fill: "#C0AD9E",
    stroke: "#C0AD9E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5008 37.5318L27.5973 36.9105H22.3837L21.4802 37.5318L21.0095 41.6922L21.4423 41.2774H28.5387L29.0094 41.6922L28.5008 37.5318Z",
    fill: "#161616",
    stroke: "#161616",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4003 15.5646L48.9999 7.88487L46.6095 0.750641L28.5007 14.1904L35.4654 20.0821L45.3102 22.9621L47.4941 20.4212L46.5527 19.744L48.0585 18.3698L46.8918 17.4663L48.3976 16.3175L47.4003 15.5646Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M1 7.88487L2.59959 15.5646L1.58339 16.3175L3.08922 17.4663L1.94138 18.3698L3.44721 19.744L2.50583 20.4212L4.67082 22.9621L14.5155 20.0821L21.4802 14.1904L3.37145 0.750641L1 7.88487Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M45.31 22.9621L35.4653 20.0821L38.4589 24.5816L33.9973 33.2397L39.8701 33.1649H48.6238L45.31 22.9621Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5154 20.0821L4.67067 22.9621L1.39478 33.1649H10.1295L15.9833 33.2397L11.5407 24.5816L14.5154 20.0821Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8797 25.0523L28.501 14.1904L31.363 6.45387H18.6562L21.4804 14.1904L22.1386 25.0523L22.365 28.4778L22.3839 36.9105H27.5975L27.6354 28.4778L27.8797 25.0523Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMetamask);
export default __webpack_public_path__ + "static/media/logo-metamask.2351b080138ddbee2aef9ba87cc2a951.svg";
export { ForwardRef as ReactComponent };